import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, LOCALE_ID, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PagesService } from '@services/pages.service';
import { SharedService } from '@services/shared.service';
import { AuthService } from 'src/app/Auth/AuthService';
import { environment } from '@env';

@Component({
  selector: 'app-forgotpassword',
  standalone: true,
  imports: [RouterLink, ReactiveFormsModule, CommonModule, TranslateModule],
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.scss', '../../../../auth.scss'],

})
export class ForgotComponent implements OnInit {
  baseUrl = environment.baseUrl;
  ForgetPasswordForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private route: Router,
    private authService: AuthService,
    private pageService: PagesService,
    private sharedService: SharedService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.ForgetPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
    const sessionId = new URLSearchParams(window.location.search).get(
      'session_id'
    );
    if (sessionId) {
      const data = {
        session_id: sessionId,
      };
      this.pageService.update('CHECK_PAYMENT', data).subscribe({
        next: (response: any) => {
          const isSuccess = response?.data?.isSuccess || response?.isSuccess || response?.status === 'paid' || response?.data?.status === 'paid';
          if (isSuccess || !response?.error) {
            this.route.navigate(['/auth/payment-approved'], {
              queryParams: { session_id: sessionId }
            });
          }
        },
      });
    }
  }

  sendResetLink() {
    this.sharedService.showLoader();
    const currentLang = localStorage.getItem('lang') || this.translate.currentLang || 'en';
    this.pageService
      .create('SEND_RESET_LINK', {
        email: this.ForgetPasswordForm.value.email,
        lang: currentLang,
        language: currentLang
      })
      .subscribe({
        next: (response: any) => {
          this.sharedService.hideLoader();
          if (response.isSuccess) {
            // The backend's `message` field is always returned in English regardless of
            // site locale, so show our own translated copy instead of the raw API text.
            this.sharedService.createNotification(
              'success',
              this.translate.instant('common.reset-link-sent')
            );

            const url = new URL(window.location.href);
            url.searchParams.delete('session_id');
            window.history.replaceState({}, '', url.toString());
            this.route.navigate(['/auth/reset-password']);
          } else {
            this.sharedService.createNotification(
              'error',
              this.translate.instant('common.reset-link-failed')
            );
          }
        },
        error: (err: any) => {
          this.sharedService.hideLoader();
          this.sharedService.createNotification(
            'error',
            this.translate.instant('common.reset-link-failed')
          );
        },
      });
  }
}
